export { sessionStorage } from '@apparel/core/storage';
